import { atom, useAtom } from 'jotai';

type UseLinkAggregationFilter = {
  linkAggregationFilter: [number, number] | null;
  setLinkAggregationFilter: (range: [number, number] | null) => void;
};

const linkAggregationFilterAtom = atom<[number, number] | null>(null);

const useLinkAggregationFilter = (): UseLinkAggregationFilter => {
  const [linkAggregationFilter, setLinkAggregationFilter] = useAtom(
    linkAggregationFilterAtom
  );

  return {
    linkAggregationFilter,
    setLinkAggregationFilter,
  };
};

export { useLinkAggregationFilter };
